import React, { SVGProps } from 'react'
const SvgSearchTopBar = (
  props: SVGProps<SVGSVGElement>,
): React.ReactElement => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    aria-hidden="true"
    {...props}
  >
    <g clipPath="url(#search-top-bar_svg__a)">
      <path
        stroke="#1B2C4F"
        strokeLinecap="round"
        strokeWidth={1.5}
        d="M11.583 11.667a5.833 5.833 0 1 0-8.165-8.333 5.833 5.833 0 0 0 8.165 8.333Zm0 0 6.75 6.666"
      />
    </g>
    <defs>
      <clipPath id="search-top-bar_svg__a">
        <path fill="#fff" d="M0 0h20v20H0z" />
      </clipPath>
    </defs>
  </svg>
)
export default SvgSearchTopBar
